/** @jsx jsx */
import { Box, jsx } from 'theme-ui'
import { FC, SVGProps } from 'react'

enum Direction {
  'up' = 'up',
  'down' = 'down',
  'left' = 'left',
  'right' = 'right',
}

type Props = SVGProps<SVGSVGElement> & {
  color?: string
  direction?: Direction
}

const rotate = (direction: Direction) => {
  switch (direction) {
    case 'down':
      return `rotate(90deg)`
    case 'left':
      return `rotate(180deg)`
    case 'up':
      return `rotate(-90deg)`
    case 'right':
    default:
      return 'none'
  }
}

export const ArrowRugs: FC<Props> = ({
  color = 'currentColor',
  direction = Direction.right,
  ...rest
}) => {
  return (
    <Box
      as="svg"
      {...rest}
      // @ts-ignore
      width="15"
      height="10"
      viewBox="0 0 95 31"
      fill="none"
      sx={{
        transform: rotate(direction),
      }}
    >
      <path
        d="M67.912 30.2C69.192 27.4693 70.4293 25.08 71.624 23.032C72.904 20.984 74.1413 19.2773 75.336 17.912H0.712002V12.536H75.336C74.1413 11.0853 72.904 9.336 71.624 7.288C70.4293 5.24 69.192 2.89333 67.912 0.247997H72.392C77.768 6.47733 83.4 11.0853 89.288 14.072V16.376C83.4 19.2773 77.768 23.8853 72.392 30.2H67.912Z"
        fill="#595858"
      />
    </Box>
  )
}
